import gql from 'graphql-tag';

export default fields => gql`
mutation ($input: CreateChannelInput!) {
    createChannel (input: $input) {
        __typename
        ${[...['id', 'name'].concat(fields)]}
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/Channels/NewMutation.js